import React from 'react';
import PropTypes from 'prop-types';

import { VpInfoMenu } from '../../components';
import { useMediaTableContext, useForceDownload } from '../../../hooks';

const MENU_ITEMS = [
  {
    id: 'download',
    label: 'Download',
    icon: 'DownloadCloud'
  },
  {
    id: 'delete',
    label: 'Delete',
    icon: 'Trash2',
    variant: 'error'
  }
];

export const VpAttachmentInfoMenu = ({ media }) => {
  const id = media?.mediaId || media?.attachmentId;
  const { forceDownload, isLoading } = useForceDownload();

  const { setSelectedEntity } = useMediaTableContext();

  const onSelect = (item) => {
    switch (item?.id) {
      case 'download': {
        forceDownload(media?.previewUrl, media?.originalFileName);
        return;
      }
      case 'delete': {
        setSelectedEntity(media);
        return;
      }
    }
  };

  return <VpInfoMenu id={id} isLoading={isLoading} menuItems={MENU_ITEMS} onSelect={onSelect} />;
};

VpAttachmentInfoMenu.propTypes = {
  media: PropTypes.object
};

export default VpAttachmentInfoMenu;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpAttachmentInfoMenu.jsx